import type { BrandConfig } from "./types";

const brandConfig: BrandConfig = {
  name: "Midcoast",
  logo: "/logo.webp",
  icon: "/icon.webp",
  favicon: "/favicon.ico",
  secondaryLogo: "/midcoast2.webp",
  secondaryLogoSize: 250,
  logoSize: 80,
  apiUrl: "https://api.midcoast.waterbureau.com.au",
  features: {
    deviceTypeFilter: false,
    deviceControls: true,
    addDeviceButtonPlacement: "top",
    brandingIcon: false,
    deviceTypeIcon: false,
    deviceSubTypeIcon: false,
    deviceItemAccentLine: false,
    tenantBadge: true,
    settingsNotifications: false,
  },
  header: {
    variant: "waterbureau",
    accentText: "Water",
    normalText: "Bureau",
  },
  strings: {
    logoAlt: "Midcoast Logo",
    copyright: "© 2025 Midcoast. All rights reserved.",
    supportEmail: "support@waterbureau.com",
    councilName: "Water Bureau",
  },
};

export default brandConfig;

let currentBrandConfig: BrandConfig = { ...brandConfig };

export function getCurrentBrandConfig(): BrandConfig {
  return currentBrandConfig;
}

export function updateCurrentBrandConfig(partial: Partial<BrandConfig>) {
  currentBrandConfig = { ...currentBrandConfig, ...partial };
}
